<template>
  <Tooltip :key="appointment.service_category.id" :options="options">
    <template #trigger>
      <div
        data-cy="service-category-trigger"
        :class="[
          'p-1 ml-3 hover:bg-blue-50 cursor-pointer rounded-lg',
          { 'bg-blue-50': visible }
        ]"
      >
        <div class="text-lg font-medium">
          {{ appointment.service_category.name }}
        </div>
        <div class="text-sm font-medium text-gray-500">
          Appointment ID #{{ appointment.id }}
        </div>
      </div>
    </template>
    <template #tooltip
      ><ServiceCategoryForm
        :appointment="appointment"
        @saved="emit('refresh-appointment')"
    /></template>
  </Tooltip>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Tooltip from "@/components/Tooltip.vue";
import { AppointmentV2 } from "@/typings/appointment";
import ServiceCategoryForm from "./ServiceCategoryForm.vue";

const emit = defineEmits(["refresh-appointment"]);
defineProps<{ appointment: AppointmentV2 }>();
const visible = ref(false);
const options = ref({
  appendTo: document.body,
  interactive: true,
  hideOnClick: true,
  distance: -10,
  arrow: false,
  placement: "bottom",
  trigger: "click",
  theme: "actions-menu light",
  onShow: () => (visible.value = true),
  onHidden: () => (visible.value = false)
});
</script>

<style lang="scss" scoped></style>
